import { observer } from 'mobx-react-lite'
import { type IRow, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { TableSearch } from 'shared/ui/TableNew'
import { type KnowledgeBaseDocument } from 'entities/KnowledgeBase'
import { useKnowledgeBaseViewContext } from 'pages/settings/pages/knowledgeBase/context/knowledgeBaseViewContext'
import { KnowledgeBaseUrlAlert } from 'pages/settings/pages/knowledgeBase/pages/knowledgeBaseView/ui/KnowledgeBaseNotifications/KnowledgeBaseUrlAlert'
import { useDocumentsWithActionsRows } from './ui/useDocumentsWithActionsRows'
import { DocumentsBulkActions } from './ui/DocumentsBulkActions'
import { columns, isSupportedFormat } from './ui/columns'
import styles from './styles.module.scss'

export const DocumentsTable = observer(() => {
  const {
    documentsStore: {
      page,
      limit,
      total,
      isDocumentsLoading,
      onPaginationChange,
      tableStore,
      search,
      onSearchChange,
      onPreview,
    },
  } = useKnowledgeBaseViewContext()

  const rows = useDocumentsWithActionsRows()

  const onRowClick = (row: IRow<KnowledgeBaseDocument>) => {
    if (isSupportedFormat(row)) {
      onPreview(row)
    }
  }

  return (
    <>
      <TableSearch value={search} onChange={onSearchChange} />
      <KnowledgeBaseUrlAlert margin='12px 6px 20px 0' />
      <div className={styles.table}>
        {!isDocumentsLoading && !rows.length ? (
          <NoResultsFound boxProps={{ flexGrow: 1, height: undefined }} />
        ) : (
          <Table
            ariaLabel={'DocumentsTable'}
            columns={columns}
            rows={rows}
            initPage={page}
            limit={limit}
            store={tableStore}
            isLoading={isDocumentsLoading}
            pinnedColumnNames={['name']}
            rowsCount={total}
            onChangePagination={onPaginationChange}
            startPaginationSize={10}
            headerLeftContentProps={{
              actionsContent: <DocumentsBulkActions />,
            }}
            withCheckbox
            onRowClick={onRowClick}
          />
        )}
      </div>
    </>
  )
})
